<template>
<div>
  <action-button @click="$emit('close-testing')">Edit</action-button>
  <text-area 
    required
    :error="$root.errorBag.payload"
    description="We are simulating a test payload that has been scraped from a client."
    v-model="payload">Test Payload</text-area> 

  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Standard</th>
        <th>Expected Value</th>
        <th>Outcome</th>
      </tr>
    </thead>
    <tbody>
      <test-outcome 
        :section="section" 
        :results="results"
        v-for="section in standards" 
        :key="section.id" />
    </tbody>
  </table>

  <action-button :working="runningTest" @click="runTest">Run Test</action-button> 
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import { post } from '@/api/request'
import TestOutcome from './partials/StandardTestOutcome.vue'

export default {

  components: {
    TestOutcome
  },
  
  data: () => ({
    runningTest: false,
    payload: '',
    standards: [],
    results: []
  }),

  created() {
    this.standards = this.assessor.standards
  },

  methods: {
    runTest() {
      this.runningTest = true
      post('api/super/test-assessor', {
        payload: this.payload,
        assessor: this.assessor
      }, ({data}) => {
        this.results = data
        this.runningTest = false
      }, error => {
        this.runningTest = false
      })
    }
  },

  computed: {
    ...mapGetters('assessor', [
      'assessor'
    ])
  }
}
</script>